import { render, staticRenderFns } from "./AccountSetting.vue?vue&type=template&id=34b0999a&scoped=true&"
import script from "./AccountSetting.vue?vue&type=script&lang=js&"
export * from "./AccountSetting.vue?vue&type=script&lang=js&"
import style0 from "./AccountSetting.vue?vue&type=style&index=0&id=34b0999a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34b0999a",
  null
  
)

export default component.exports